import { GlobalApiAuthenticationFailed } from 'components/AuthenticationFailed';
import { LoginView } from 'components/login/LoginView';
import { DecodedParamsRoute } from 'components/routing/DecodedParamsRoute';
import { RouteLoader } from 'components/routing/RouteLoader';
import { WorkspaceNotFound } from 'components/WorkspaceNotFound';
import { useFlagEnabledWithOverrides } from 'hooks/useFlagEnabledWithOverrides';
import { useUserInfo } from 'hooks/useUserInfo';
import React from 'react';
import { putLocalStorage } from 'utils/localStorage';
import { Redirect, type RouteProps } from 'wouter';
import { useAuth0 } from '@auth0/auth0-react';

import { useWorkspace } from './WorkspaceProvider';

export const ProtectedRoute = (
  props: RouteProps & { path: `/w/:workspaceId/${string}` }
) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { workspace } = useWorkspace();
  const userInfo = useUserInfo();
  const isSelfServeEnabled = useFlagEnabledWithOverrides('frontend-self-serve');

  if (!isAuthenticated && !isLoading) {
    // If the user isn't logged in, store the route the user wants to go to
    // before redirected them to the login page.
    putLocalStorage('user_redirect_href', { path: window.location.href });
    // We don't want to replace the history state here because the user
    // will be unable to leave the dashboard
    return <Redirect href="/login" />;
  }

  if (isAuthenticated && userInfo.type === 'server_error') {
    return <GlobalApiAuthenticationFailed />;
  }

  // authenticates with auth0 but not fragment
  if (isAuthenticated && userInfo.type === 'user_not_found') {
    // A self-serve user signs up before any Fragment user record exists, so
    // they land on workspace creation rather than an error.
    return isSelfServeEnabled ? (
      <Redirect href="/add-new-workspace" replace />
    ) : (
      <LoginView errorMessage="Email not found" />
    );
  }

  if (isAuthenticated && userInfo.data && !workspace) {
    return <WorkspaceNotFound />;
  }

  if (isAuthenticated && userInfo.data) {
    return <DecodedParamsRoute {...props} />;
  }
  return <RouteLoader />;
};
